export default __webpack_public_path__ + "static/media/img_25.1480745a.JPG";